import React from 'react';
import CompanyDetailsPanel from '../CompanyDetailsPanel';

interface CompanyDetailsModalProps {
  company: any;
  darkMode?: boolean;
  onClose: () => void;
}

const CompanyDetailsModal: React.FC<CompanyDetailsModalProps> = ({ company, darkMode = false, onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      background: 'rgba(0, 0, 0, 0.5)'
    }}>
      <CompanyDetailsPanel
        company={company}
        onClose={onClose}
        darkMode={darkMode}
      />
    </div>
  );
};

export default CompanyDetailsModal;